import Início from './Inicio/Inicio';
import Lista from './lista/Lista';
import Registo from './registo/Registo';
import Relatorios from './relatorios/Relatorios';
import MainLayout from '../components/layout/MainLayout'
import CreateUser from './user_create/CreateUser'
import Reset from './reset/Reset'
import User from './user_list/User';
import UpdateUser from './user_update/UpdateUser';
import SSL from './certificados_ssl/Ssl.js';
import Login from './login/login2'


export { Início, Lista, Registo, Relatorios, MainLayout, Login, CreateUser, User, UpdateUser, Reset, SSL }